// Import Packages
import React, { useEffect } from 'react';
import LazyLoad from "react-lazyload";

// Import Material UI
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

// Import CSS
import './StepBar.css';

/**
 * @Description this function displays a process with the given values
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function Details({ percentage, icon, message }) {

    return (
        <Dialog open={true} maxWidth="sm" >
            <div className='step-bar-container'>
                {percentage ?
                    <div className='step-bar'>
                        <div className='step-bar-percentage' style={{ width: percentage }}></div>
                    </div> :
                    <div className='icon-container'>
                        <LazyLoad height={33} >
                            <img src={icon} height={33}/>
                        </LazyLoad>
                    </div>
                }

                <div className='items-center-center'>
                    {percentage && <CircularProgress className='step-bar-loading' />}
                    <div className='step-bar-message' >{message}</div>
                </div>
            </div>
        </Dialog >
    );
}

export default Details;
